<template>
  <van-popup class="c-appshare" :class="themeClass" v-model="show" position="bottom">
    <div class="c-appshare-containner" ref="containner">
      <div class="section-preview">
        <img class="section-preview-img" :src="innerShareOptions.previewImageUrl" alt="" v-if="innerShareOptions.previewImageUrl" />
      </div>
      <div class="section-share-containner">
        <div class="section-share-header">
          <span class="title">分享给好友</span>
          <em class="btn-cancel" @click="handleCancel">
            <svg-icon icon-class="close"></svg-icon>
          </em>
        </div>
        <div class="section-share-list">
          <div class="section-share-item" :class="item.name === 'CopyUrl' ? 'btn-copy-link' : ''" v-for="item in mainApiList" :key="item.id" @click="openAppShare(item)">
            <img class="section-share-item-icon" :src="item.icon" />
            <div class="section-share-item-label">{{ item.label }}</div>
          </div>
        </div>
        <div class="section-share-footer">
          <button type="button" class="btn-confirm" v-for="item in bottomApiList" :key="item.id" @click="openAppShare(item)">分享到即刻</button>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import { Popup as VanPopup } from 'vant';
import Clipboard from 'clipboard';
import iconWechat from '@/assets/images/components/icon-wechat@2x.png';
import iconWechatMoments from '@/assets/images/components/icon-wechatMoments@2x.png';
import iconWeibo from '@/assets/images/components/icon-weibo@2x.png';
import iconQQ from '@/assets/images/components/icon-qq@2x.png';
import iconDingtalk from '@/assets/images/components/icon-dingtalk@2x.png';
import iconZeeho from '@/assets/images/components/icon-zeeho@2x.png';
import iconAlbum from '@/assets/images/components/icon-album@2x.png';
import iconLink from '@/assets/images/components/icon-link@2x.png';
import { EVENT_SHARE_FROMS, SHARE_FROMS } from '@/constant';
import { queryParse, queryStringify } from 'cfmoto-utils';
export default {
  props: {
    theme: {
      type: String,
      default: 'default',
    },
  },
  components: { VanPopup },
  data() {
    return {
      show: false,
      innerShareOptions: {
        // apiList: ['Wechat', 'WechatMoments', 'QQ', 'SinaWeibo', 'DingTalk', 'Zeeho', 'ZeehoMoments', 'Album', 'CopyUrl'],
        apiList: [SHARE_FROMS.Wechat, SHARE_FROMS.WechatMoments, SHARE_FROMS.QQ, SHARE_FROMS.DingTalk, SHARE_FROMS.Zeeho, SHARE_FROMS.ZeehoMoments, SHARE_FROMS.Album, SHARE_FROMS.CopyUrl],
        // apiList: ['Wechat', 'WechatMoments', 'SinaWeibo', 'CopyUrl'],
        title: '',
        titleUrl: '',
        text: '',
        url: '',
        shareType: '',
        success: () => {},
        fail: () => {},
        complete: () => {},
      },
      containerHeight: '100%',
    };
  },
  computed: {
    themeClass() {
      return this.theme;
    },
    styles() {
      return {
        '--container-height': this.containerHeight,
        height: this.containerHeight,
      };
    },
    apiDatas() {
      return {
        Wechat: { icon: iconWechat, label: ' 微信 ', fromName: EVENT_SHARE_FROMS.SHARE_WECHART.key },
        WechatMoments: { icon: iconWechatMoments, label: ' 朋友圈 ', fromName: EVENT_SHARE_FROMS.SHARE_WECHART_MOMENTS.key },
        SinaWeibo: { icon: iconWeibo, label: '微博', fromName: EVENT_SHARE_FROMS.SHARE_WEIBO.key },
        QQ: { icon: iconQQ, label: ' QQ ', fromName: EVENT_SHARE_FROMS.SHARE_QQ.key, hideHarmonyNext: true },
        DingTalk: { icon: iconDingtalk, label: '钉钉', fromName: EVENT_SHARE_FROMS.SHARE_DINGTALK.key, hideHarmonyNext: true },
        Zeeho: { icon: iconZeeho, label: ' 好友 ', fromName: EVENT_SHARE_FROMS.SHARE_ZEEHO.key, hideHarmonyNext: true },
        ZeehoMoments: { icon: '', label: '极客', fromName: EVENT_SHARE_FROMS.SHARE_ZEEHO_MOMENTS.key, position: 'bottom' },
        Album: { icon: iconAlbum, label: ' 保存图片 ', fromName: EVENT_SHARE_FROMS.SHARE_ALBUM.key },
        Letter: { icon: '', label: ' 私信和群 ' },
        CopyUrl: { icon: iconLink, label: '复制链接', fromName: EVENT_SHARE_FROMS.SHARE_COPY.key },
      };
    },
    apiList() {
      const apiList = this.innerShareOptions.apiList.map((name) => {
        const item = this.apiDatas[name];
        return { ...item, name, id: Math.random() };
      });
      return apiList.filter((item) => !this.isHarmonyNext || !item.hideHarmonyNext);
    },
    mainApiList() {
      return this.apiList.filter((item) => item.position !== 'bottom');
    },
    bottomApiList() {
      return this.apiList.filter((item) => item.position === 'bottom');
    },
  },
  methods: {
    setOptions(options = {}) {
      const apiList = this.innerShareOptions.apiList;
      this.innerShareOptions = { ...this.innerShareOptions, ...JSON.parse(JSON.stringify(options)), success: options.success || this.success, fail: options.fail || this.fail };
      this.innerShareOptions.apiList = this.innerShareOptions.apiList.length ? this.innerShareOptions.apiList : apiList;
    },
    async open(options = {}) {
      this.setOptions(options);
      // if (options.previewPosterUrl && !this.previewPosterUrl) {
      //   this.previewPosterUrl = await options.previewPosterUrl();
      //   console.log(this.previewPosterUrl);
      // }
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.show = true;
      this.copyUrl();
    },
    hide() {
      this.show = false;
    },
    handleCancel() {
      this.show = false;
    },
    copyUrl() {
      const queryData = { ...queryParse(this.innerShareOptions.titleUrl), shareFrom: EVENT_SHARE_FROMS.SHARE_COPY.key };
      const titleUrl = this.innerShareOptions.titleUrl.split('?')[0] + '?' + queryStringify(queryData);
      this.$nextTick(() => {
        const clipboard = new Clipboard('.btn-copy-link', {
          // 绑定需要的触发的dom
          text() {
            return titleUrl;
          },
        });

        clipboard.on('success', (e) => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.success && this.innerShareOptions.success(e);
          this.show = false;
          this.$toast('复制成功');
        });
        clipboard.on('error', (e) => {
          this.innerShareOptions.complete && this.innerShareOptions.complete(e);
          this.innerShareOptions.error && this.innerShareOptions.error(e);
        });
      });
    },
    openAppShare(item, index) {
      console.log('我点击了' + item.name);
      console.log(window.android);
      const { success } = this.innerShareOptions;
      // if (item.name === 'CopyUrl') {
      //   return;
      // }
      if (success) {
        success({ ...item, index });
      }
    },
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-appshare {
  overflow: visible;
  display: inline;
  flex-direction: column;
  align-items: center;
  height: var(--root-height);
  // position: fixed;
  box-shadow: 0px calc(var(--viewport-ratio) * 2px) calc(var(--viewport-ratio) * 8px) 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: calc(var(--viewport-ratio) * 8px);
  --van-popup-round-border-radius: 0;
  --van-action-sheet-header-height: 54px;
  background: none;
  line-height: 1;
  &-containner {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    width: calc(var(--viewport-ratio) * 375px);
    height: var(--root-height);
  }
  .section-preview {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    padding: calc(var(--viewport-ratio) * 44px) 0 calc(var(--viewport-ratio) * 20px);
    overflow: hidden;
    &-img {
      height: 100%;
      border-radius: calc(var(--viewport-ratio) * 20px);
    }
  }
  .section-share-containner {
    position: relative;
    width: calc(var(--viewport-ratio) * 375px);
    min-height: calc(var(--viewport-ratio) * 167px);
    background: rgba(255, 255, 255, 1);
    border-radius: calc(var(--viewport-ratio) * 18px) calc(var(--viewport-ratio) * 18px) 0px 0px;
    // transform: scale(var(--viewport-ratio));
  }

  .section-share-header {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    padding: calc(var(--viewport-ratio) * 20px) 0 0;
    line-height: 1.5;
    .title {
      // margin-left: 24px;
      font-weight: 500;
      font-size: calc(var(--viewport-ratio) * 18px);
      color: #101010;
    }
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: calc(var(--viewport-ratio) * 20px);
      right: calc(var(--viewport-ratio) * 26px);
      width: calc(var(--viewport-ratio) * 30px);
      height: calc(var(--viewport-ratio) * 30px);
      font-size: calc(var(--viewport-ratio) * 24px);
      color: #000000;
    }
  }
  .section-share-footer {
    position: relative;
    top: 0;
    width: 100%;
    margin: 0 0;
    padding: 0 0 calc(var(--viewport-ratio) * 10px);
    display: flex;
    flex-direction: column;
    align-items: center;

    // display: none;
    background-color: #ffffff;
    .btn-confirm {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: none;
      width: calc(var(--viewport-ratio) * 340px);
      height: calc(var(--viewport-ratio) * 44px);
      background: #101010;
      border-radius: calc(var(--viewport-ratio) * 4px);
      font-weight: 500;
      font-size: calc(var(--viewport-ratio) * 16px);
      color: #ffffff;
    }
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      flex: 1;
      border: none;
      position: absolute;
      top: 0;
      padding: 0;
      height: calc(var(--viewport-ratio) * 48px);
      background: #ffffff;
      box-shadow: 0px calc(var(--viewport-ratio) * 2px) calc(var(--viewport-ratio) * 8px) 0px rgba(0, 0, 0, 0.12);
      border-radius: calc(var(--viewport-ratio) * 8px);
      font-size: calc(var(--viewport-ratio) * 14px);
      font-weight: 400;
      color: #666666;
      &:active {
        color: #555555;
      }
    }
  }
  .section-share-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    box-sizing: border-box;
    margin-bottom: calc(var(--viewport-ratio) * -10px);
    padding: calc(var(--viewport-ratio) * 30px) calc(var(--viewport-ratio) * 32px) calc(var(--viewport-ratio) * 18px);
  }
  .section-share-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 calc(var(--viewport-ratio) * 37px) calc(var(--viewport-ratio) * 14px) 0;
    &:nth-of-type(4n) {
      margin-right: 0 !important;
    }
  }
  .section-share-item-icon {
    width: calc(var(--viewport-ratio) * 50px);
    height: calc(var(--viewport-ratio) * 50px);
    object-fit: contain;
  }
  .section-share-item-label {
    margin: calc(var(--viewport-ratio) * 10px) 0 0;
    font-size: calc(var(--viewport-ratio) * 12px);
    font-weight: 400;
    color: #000000;
  }
}
.c-appshare.opacity {
  box-shadow: 0px calc(var(--viewport-ratio) * 2px) calc(var(--viewport-ratio) * 8px) 0px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: calc(var(--viewport-ratio) * 8px);
  --van-popup-round-border-radius: 0;
  --van-action-sheet-header-height: calc(var(--viewport-ratio) * 54px);
  background: none;
  line-height: 1;
  .section-share-containner {
    width: 375px;
    min-height: calc(var(--viewport-ratio) * 247px);
    background: rgba(255, 255, 255, 0.27);
    border-radius: calc(var(--viewport-ratio) * 18px) calc(var(--viewport-ratio) * 18px) 0px 0px;
  }
  .section-share-header {
    position: relative;
    width: 100%;
    justify-content: flex-start;
    padding: calc(var(--viewport-ratio) * 24px) 0;
    line-height: 1.5;
    .title {
      margin-left: calc(var(--viewport-ratio) * 24px);
      font-weight: 600;
      font-size: calc(var(--viewport-ratio) * 14px);
      color: #ffffff;
    }
    .btn-cancel {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: absolute;
      // top: 20px;
      right: calc(var(--viewport-ratio) * 15px);
      width: calc(var(--viewport-ratio) * 30px);
      height: calc(var(--viewport-ratio) * 30px);
      font-size: calc(var(--viewport-ratio) * 12px);
      color: #ffffff;
    }
  }
  .section-share-footer {
    display: none;
  }
  .section-share-list {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 0 calc(var(--viewport-ratio) * 45px);
    .section-share-item {
      display: flex;
      flex-direction: column;
      position: relative;
      width: calc(var(--viewport-ratio) * 50px);

      &-icon {
        width: calc(var(--viewport-ratio) * 50px);
        height: calc(var(--viewport-ratio) * 50px);
        border-radius: 50%;
      }
      &-label {
        margin-top: calc(var(--viewport-ratio) * 4px);
        line-height: 1.5;
        font-weight: 400;
        font-size: calc(var(--viewport-ratio) * 12px);
        color: #ffffff;
      }
    }
  }
}
</style>
